import { useAuth0 } from "@auth0/auth0-react";
import { CompanyData_V1, CompanyData_V2 } from "@rw1/auto-generated-clients";
import { useAppConfig, useEnvConfig } from "rwo-react";
import { setAccessTokenProvider } from "./accessTokenProvider";
import { joinUrl } from ".";

let companyDataClientV1: CompanyData_V1.CompanyDataClientV1 | undefined;
let companyDataClientV2: CompanyData_V2.CompanyDataClientV2 | undefined;

export const useCompanyDataServiceV1 =
  (): CompanyData_V1.CompanyDataClientV1 => {
    const { getAccessTokenSilently } = useAuth0();
    const { backendAddress } = useEnvConfig();
    const { config } = useAppConfig();

    companyDataClientV1 ??= companyDataClientV1 =
      new CompanyData_V1.CompanyDataClientV1(
        joinUrl(backendAddress, config["CompanyDataApiSuffix"])
      );
    setAccessTokenProvider(companyDataClientV1, getAccessTokenSilently);

    return companyDataClientV1;
  };

export const useCompanyDataServiceV2 =
  (): CompanyData_V2.CompanyDataClientV2 => {
    const { getAccessTokenSilently } = useAuth0();
    const { backendAddress } = useEnvConfig();
    const { config } = useAppConfig();

    companyDataClientV2 ??= companyDataClientV2 =
      new CompanyData_V2.CompanyDataClientV2(
        joinUrl(backendAddress, config["CompanyDataV2ApiSuffix"])
      );
    setAccessTokenProvider(companyDataClientV2, getAccessTokenSilently);

    return companyDataClientV2;
  };
